/**
 * Created by smizrahi on 7/27/16.
 */

export const STEP_PAUSE_TYPE = 'pause';

export default class ConfigStepPause {
    constructor(pause) {
        this.type = STEP_PAUSE_TYPE;
        this.pause = parseInt(pause);
        Object.freeze(this);
    }

    static restore(obj) {
        return new ConfigStepPause(obj.pause);
    }
}


// WEBPACK FOOTER //
// ./js/core/configuration/config/ConfigStepPause.js